import styled from "styled-components";

import images from "images";

const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   background-color: black;
   color: white;
   width: 100%;
   padding: 1px 0 7px 0;
`;

const LogoWrap = styled.div`
   padding: 22px 0;
`;
const Logo = styled.img`
   height: 18px;
`;

const FieldsWrap = styled.div`
   display: flex;
   flex-direction: row;
   justify-content: space-around;
   width: 100%;
   padding: 20px 0 26px 0;
`;
const Fields = styled.div`
   display: flex;
   flex-direction: column;
   gap: 22px;
`;
const Field = styled.div`
   font-weight: 600;
   font-size: 16px;
   line-height: 20px;
`;

const Divider = styled.div`
   width: 1000px;
   max-width: 100%;
   height: 0.5px;
   background-color: white;
`;

const Copyright = styled.div`
   font-weight: 400;
   font-size: 14px;
   line-height: 20px;
   padding-bottom: 10px;
   color: #888888;
`;

const WarningAlert = styled.div`
   font-weight: 400;
   font-size: 14px;
   line-height: 20px;
   padding-bottom: 30px;
   color: #888888;
   text-align: center;
`;

function Footer(props: any) {
   return (
      <Wrap className={props.className}>
         <LogoWrap>
            <Logo src={images.footerLogo}></Logo>
         </LogoWrap>
         <Copyright>Copyright © 2022 ARTMAP Corp. All Rights Reserved.</Copyright>
         <WarningAlert>아트맵은 위치기반/ 취향데이터분석 특허2건 기반 서비스 제공 중이므로 이에 관한 관련 침해에 대해서는 법적 문제를 초래 할수 있습니다.</WarningAlert>
         <Divider></Divider>
         <FieldsWrap>
            <Fields>
               <Field>
                  대외 총괄·제안
                  <br />
                  info@art-map.co.kr
               </Field>
               <Field>
                  기획·홍보
                  <br />
                  biz@art-map.co.kr
               </Field>
            </Fields>
            <Fields>
               <Field>
                  전시 등록·관리
                  <br />
                  contact@art-map.co.kr
               </Field>
               <Field>
                  Tel
                  <br />
                  070-7740-1267
               </Field>
            </Fields>
         </FieldsWrap>
      </Wrap>
   );
}

export default Footer;
